var map = {
	"./Anvil.webp": 2386,
	"./Clippers.webp": 4838,
	"./Forge.webp": 1511,
	"./Hammer.webp": 7874,
	"./Sword.webp": 1517,
	"./Table.webp": 5516,
	"./allImg.webp": 8078,
	"./cursed_finger.gif": 7363,
	"./cursed_finger_2.gif": 6956,
	"./dev1.png": 6406,
	"./dev2.webp": 9423,
	"./dev7.png": 8368,
	"./dev8.png": 3111,
	"./dev9.png": 622,
	"./games/bothmcb-1.jpg": 4961,
	"./games/bothmcb-2.jpg": 5350,
	"./games/bothmcb-3.jpg": 611,
	"./games/desk-pond-day.jpg": 8486,
	"./games/desk-pond-icon.png": 5993,
	"./games/desk-pond-night.jpg": 3434,
	"./games/desk-pond-stats.jpg": 7605,
	"./gd1.webp": 7066,
	"./gd2.png": 1623,
	"./gd3.png": 286,
	"./gd4.png": 6401,
	"./gd6.webp": 8263,
	"./gd7.webp": 7252,
	"./loadingGif.gif": 8293,
	"./logo.png": 3653,
	"./ph1.jpg": 663,
	"./ph10.jpg": 9031,
	"./ph3.jpg": 5957,
	"./ph4.jpg": 6718,
	"./ph5.jpg": 6875,
	"./ph6.jpg": 428,
	"./ph7.jpg": 8217,
	"./ph8.jpg": 5506,
	"./ph9.jpg": 1887,
	"./sleeping_character.jpg": 1075,
	"./thgd.png": 7253,
	"./thph.jpg": 3804,
	"./ul1.JPG": 8218,
	"./ul10.JPG": 600,
	"./ul11.JPG": 7285,
	"./ul12.JPG": 8266,
	"./ul13.JPG": 7412,
	"./ul14.JPG": 9292,
	"./ul15.JPG": 7305,
	"./ul16.JPG": 2542,
	"./ul17.JPG": 2859,
	"./ul2.JPG": 6389,
	"./ul3.JPG": 1736,
	"./ul4.JPG": 8267,
	"./ul5.JPG": 1582,
	"./ul6.JPG": 3337,
	"./ul7.JPG": 5484,
	"./ul8.JPG": 2559,
	"./ul9.JPG": 4738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;